// todo: use these in our .graphql files
export const EVENT_SLUG = "hackthenorth2020";

export enum PipelineSlug {
  MILESTONES = "milestones",
  SPONSOR_COMPANIES = "sponsor-companies",
  SPONSOR_INDIVIDUALS = "sponsor-individuals",
  SPONSOR_PERKS = "sponsor-perks",
}
